<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7" fill="none">
<path d="M0.719965 1.73999C0.719965 1.54999 0.789967 1.35999 0.939966 1.20999C1.22997
 0.919993 1.70997 0.919993 1.99997 1.20999L4.99997 4.20999L7.99997 1.20999C8.28997
  0.919993 8.76997 0.919993 9.05997 1.20999C9.34997 1.49999 9.34997 1.97999 9.05997
   2.26999L5.52997 5.79999C5.23997 6.08999 4.75997 6.08999 4.46997 5.79999L0.939966
    2.26999C0.789967 2.11999 0.719965 1.92999 0.719965 1.73999Z"
    :fill="color ? color : theme === 'light' ? 'var(--color-icon)' : 'var(--color-icon)'"/>
</svg>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
  },
  props: {
    width: {
      type: String,
      default: '28',
    },
    height: {
      type: String,
      default: '20',
    },
    color: {
      type: String,
    },
  },
};
</script>
